import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

Pusher.logToConsole = true;

const echo = new Echo({

    broadcaster: "pusher",

    // key: "42d3ad64fc70c441c268",
    key: "3c706998df156ed9a0cf",

    cluster: "ap2",

    forceTLS: true,

});

export default echo;